/**
 * Gets the parameter in each bit of the flag.
 * @param flag - First byte of the main header.
 * @returns The parameters.
 */
export function parseFlagParameters(flag) {
    return {
        y16BitPrecision: (flag & 1) !== 0,
        useExperimentExtension: (flag & 2) !== 0,
        multiFile: (flag & 4) !== 0,
        zValuesRandom: (flag & 8) !== 0,
        zValuesUneven: (flag & 16) !== 0,
        customAxisLabels: (flag & 32) !== 0,
        xyxy: (flag & 64) !== 0,
        xy: (flag & 128) !== 0,
    };
}
//# sourceMappingURL=headerUtilities.js.map